<template>
  <div>
    <b-modal id="modal" hide-footer size="lg" v-on:hidden="modalHidden()">
      <template v-slot:modal-title>
        Récapitulatif
      </template>
      <template v-slot:modal-header-close>
        <span class="modal-close-label">Poursuivre ma commande</span> ×
      </template>
      <div>
        <form>
          <div class="form-group row">
            <label for="clientName" class="col-sm-2 col-form-label">Nom*</label>
            <div class="col-sm-10">
              <input v-model="userInputs.name.value"
                     :required="userInputs.name.required"
                     :class="{'border border-warning': missingData && userInputs.name.required && userInputs.name.value === ''}"
                     type="text" class="form-control" id="clientName" placeholder="Votre nom">
            </div>
          </div>
          <div class="form-group row">
            <label for="clientPhone" class="col-sm-2 col-form-label">Téléphone*</label>
            <div class="col-sm-10">
              <input v-model="userInputs.phone.value"
                     :required="userInputs.phone.required"
                     :class="{'border border-warning': missingData && userInputs.phone.required && userInputs.phone.value === ''}"
                     type="tel" class="form-control" id="clientPhone" placeholder="Votre numéro de téléphone">
            </div>
          </div>
          <div class="form-group row">
            <label for="clientEmail" class="col-sm-2 col-form-label">Email*</label>
            <div class="col-sm-10">
              <input v-model="userInputs.email.value"
                     :required="userInputs.email.required"
                     :class="{'border border-warning': missingData && userInputs.email.required && (userInputs.email.value === '' || !validEmail(userInputs.email.value))}"
                     type="email" class="form-control" id="clientEmail" placeholder="Votre email">
            </div>
          </div>
          <div class="form-group row mb-5">
            <label for="clientComment" class="col-sm-2 col-form-label">Commentaire</label>
            <div class="col-sm-10">
              <textarea v-model="userInputs.comment.value"
                     :required="userInputs.comment.required"
                     :class="{'border border-warning': missingData && userInputs.comment.required && userInputs.comment.value === ''}"
                        class="form-control" id="clientComment" placeholder="Commentaire éventuel"></textarea>
            </div>
          </div>
          <div class="mb-3" v-if="shippingOption">
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="userShipping" value="oui" type="radio" class="custom-control-input" id="clientShipping1">
              <label class="custom-control-label" for="clientShipping1">Livraison à domicile <span class="text-muted d-block">Si commune élligible à livraison</span></label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input v-model="userShipping" value="non" type="radio" class="custom-control-input" id="clientShipping0">
              <label class="custom-control-label" for="clientShipping0">&Agrave; emporter le {{deliveryDate}}</label>
            </div>
          </div>
          <div v-show="userInputs.shipping.value === 'oui'" class="mb-3">
            <div class="form-group row">
              <label for="clientAddress" class="col-sm-2 col-form-label">Adresse</label>
              <div class="col-sm-10">
                <input v-model="userInputs.address.value"
                       :required="userInputs.address.required"
                       :class="{'border border-warning': missingData && userInputs.address.required && userInputs.address.value === ''}"
                       type="text" class="form-control" id="clientAddress" placeholder="Avenue ...">
              </div>
            </div>
            <div class="form-group row">
              <label for="clientPostcode" class="col-sm-2 col-form-label">Code postal et Ville</label>
              <div class="col-sm-4">
                <input v-model="userInputs.postcode.value"
                       :required="userInputs.postcode.required"
                       :class="{'border border-warning': missingData && userInputs.postcode.required && userInputs.postcode.value === ''}"
                       type="number" class="form-control" id="clientPostcode" placeholder="xxxx">
              </div>
              <div class="col-sm-6">
                <input v-model="userInputs.city.value"
                       :required="userInputs.city.required"
                       :class="{'border border-warning': missingData && userInputs.city.required && userInputs.city.value === ''}"
                       type="text" class="form-control" placeholder="Votre ville">
              </div>
            </div>
          </div>
          <article class="order-summary">
            <header>
              <h4>Votre commande</h4>
            </header>
            <ul class="list-unstyled mb-0 order-summary__item-list" v-for="item in selectedItems" :key="item.slug">
              <li v-for="row in item.rows" :key="row.slug" class="d-flex justify-content-between flex-nowrap">
                <span>
                  {{row.name}} <strong>{{row.price}}</strong>
                  <small v-if="item.commentary">{{row.commentary}}</small>
                </span>
                <div class="h5">
                  <span class="badge badge-pill badge-dark">
                    {{row.userValue}}
                  </span>
                </div>
              </li>
            </ul>
          </article>
          <div v-show="missingData" class="alert alert-warning">
            Veuillez remplir les champs requis marqué en rouge
          </div>
          <div v-if="serviceResponseError !== ''" class="alert alert-danger">
            <p>Une erreur est survenue. La commande n'a problablement pas été envoyé.</p>
            <p>Veuillez réessayer ou passer commande directement par email.</p>
            <p>Erreur <code>{{serviceResponseError}}</code></p>
          </div>
          <div class="text-right">
            <button v-on:click.prevent="modalHidden"
                    :disabled="loading"
                    type="button" class="btn btn-link">
              Retour à la sélection
            </button>
            <button v-on:click.prevent="confirm"
                    :disabled="loading"
                    type="submit" class="btn btn-primary btn-lg">
              <span v-show="loading"
                    class="spinner-border spinner-border-sm align-middle mr-2" role="status" aria-hidden="true"></span>
              <span v-show="loading">En cours de chargement...</span>
              <span v-show="!loading">Valider ma commande</span>
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: 'UserInfoModal',
    data () {
      return {
        missingData: false,
        userShipping: 'non',
        loading: false,
        serviceResponseError: '',
      }
    },
    props: {
      shippingOption: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      modalHidden() {
        this.$emit('hidden', true);
      },
      validEmail: function (email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      confirm() {
        this.serviceResponseError = '';
        this.loading = true;
        const inputs = Object.keys(this.userInputs);
        this.missingData = inputs
                              .filter(inputName => this.userInputs[inputName].required)
                              .some(requiredInputName => {
                                if (this.userInputs[requiredInputName]?.email) {
                                  return !this.validEmail(this.userInputs[requiredInputName].value)
                                }
                                return this.userInputs[requiredInputName].value === ''
                              });

        if (this.missingData) {
          this.loading = false;
          return;
        }

        this.$store.dispatch('saveOrder', {
          items: this.selectedItems
        }).then((response) => {
          this.loading = false;
          if (!response.data.success) {
            this.serviceResponseError = response.data.message;
          } else {
            this.modalHidden();
            this.$store.dispatch('showSuccessModal');
          }
        }).catch((error) => {
          this.loading = false;
          this.serviceResponseError = error;
        })
      }
    },
    computed: {
      ...mapGetters([
        'formGroups',
        'userInputs',
        'currentSpreadsheet',
        'deliveryDate'
      ]),
      selectedItems () {
        return this.$store.getters.selectedFormGroups(this.formGroups);
      },
    },
    mounted() {
      this.$bvModal.show('modal');
      this.userShipping = this.userInputs.shipping.value;
    },
    watch: {
      userShipping (val) {
        this.$store.dispatch('setUserShipping', val);
      }
    }
  }
</script>

<style scoped>
  .modal-close-label {
    font-size: 14px;
    font-weight: normal;
    vertical-align: middle;
  }

  .btn-link {
    color: #888;
  }
</style>
